import { DatePeriodType } from './enums/date-period-type.enum';

export class DateFilter {
  period: DatePeriodType;
  monthDateFrom?: Date;
  monthDateTo?: Date;
  dayDateFrom?: Date;
  dayDateTo?: Date;
  hourDateFrom?: Date;
  hourDateTo?: Date;

  minDate?: Date;
  maxDate?: Date;

  compareYears: number[];

  hidden: boolean;
  disabled: boolean;
  selected: string[];
}
